import axios from 'axios';
import { LoadingStates } from 'shared/constants/loadingStates';
import _ from 'lodash';
import { PLANT_API_BASE_URL } from 'shared/constants/constants';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const initialState = {
  data: undefined,
  status: 'idle',
  error: null,
};

const referenceDataSlice = createSlice({
  name: 'referenceData',
  initialState,
  reducers: {
    clearReferenceData() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReferenceData.pending, (state, action) => {
        state.status = LoadingStates.Loading;
      })
      .addCase(getReferenceData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = LoadingStates.Succeeded;
      })
      .addCase(getReferenceData.rejected, (state, action) => {
        state.status = LoadingStates.Rejected;
        state.error = action.error.message;
      });
  },
});

const apiUrl = `${PLANT_API_BASE_URL}/licence/PIRA/lovs/1`;

export const getReferenceData = createAsyncThunk(
  'referenceData/getReferenceData',
  async () => {
    const res = await axios.get(apiUrl, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return res.data.response;
  },
  {
    condition: (arg, { getState, extra }) => {
      const { referenceData } = getState();
      return _.isEmpty(referenceData.data);
    },
  },
);

export const { clearReferenceData } = referenceDataSlice.actions;
export const referenceDataReducer = referenceDataSlice.reducer;
